import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketNumberPipe } from './pipes/TicketNumberPipe';

@NgModule({
  declarations: [
    TicketNumberPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TicketNumberPipe
  ]
})
export class PipesModule { }
